export default {
    en: {
        id: 'diagram4b2-1',
        blocks: [
            {
                index: '1',
                task: 'S = Often face business dilemmas that require trusting someone else’s world',
                title: "S = "
            },
            {
                index: '2',
                task: 'C = Success requires some willingness to cooperate with/have faith in others',
                title: "C = "
            },
            {
                index: '3',
                task: 'Q = How much faith, and with whom?',
                title: "Q = "
            }
        ],
        answers: [
            {
                index: '2',
                title: 'Know the solution'
            },
            {
                index: '3',
                title: 'How implement?'
            },
            {
                index: '1',
                title: 'Have a problem'
            },
        ],
        title: 'Please drag the boxes with the correct algebraic structure into the right positions so that they match the SCQ statements provided.',
        correctAnswers: 3
    }
}



// WEBPACK FOOTER //
// ./client/app/modules/courses/4/4b2/spottingSCQ/i18n/exercise1.js